import{useState as r,useEffect as e}from"react";const o=()=>{const[o,t]=r(!1);return e((()=>{const r=()=>{t(window.scrollY>50)};return document.addEventListener("scroll",r),()=>{document.removeEventListener("scroll",r)}}),[o,t]),{hasScroll:o}};export{o as useScrollCheck};
//# sourceMappingURL=useScrollCheck.js.map
